import noop from "lodash/noop";

import { SWReactIcons } from "@similarweb/icons";

import HighlightTerm from "app/components/highlight-term/HighlightTerm";

import type { KeywordItemSchema } from "../types";

import * as SC from "./styles";

type KeywordItemPropsSchema = {
    onRemove: (index: number) => void;
    onSelect: (index: number) => void;
    currentKey: KeywordItemSchema;
    style: string;
    key: string;
    index: number;
    query: string;
};

const KeywordItem = ({ onRemove, onSelect, currentKey, style, key, index, query }: KeywordItemPropsSchema) => {
    const onClick = (e) => {
        e.stopPropagation();
        onRemove(index);
    };

    return (
        <SC.ListItem
            // @ts-expect-error - style is not defined on the type ListItemProps
            style={style}
            key={key}
            onClick={() => onSelect(index)}
        >
            <SC.CheckboxValueWrapper>
                <SC.StyledCheckbox
                    onClick={noop}
                    selected={currentKey.isSelected}
                />
                {query ? (
                    <SC.HighlightItemText>
                        <HighlightTerm
                            sentence={currentKey.value}
                            highlightTerm={query}
                        />
                    </SC.HighlightItemText>
                ) : (
                    <SC.ItemText>{currentKey.value}</SC.ItemText>
                )}
            </SC.CheckboxValueWrapper>

            <SC.IconWrapper onClick={onClick}>
                <SWReactIcons
                    iconName="delete"
                    size="xs"
                />
            </SC.IconWrapper>
        </SC.ListItem>
    );
};

export default KeywordItem;
